module.exports = __webpack_public_path__ + "img/fp.96ad5819.jpg";